<template>
    <div class="content">
        <div class="footer-inner">
            <!-- 品牌 + 联系方式 -->
            <div class="block_content brand-block">
                <div class="brand-name">DEBAI WOOD</div>
                <p class="brand-desc">{{ $t('home_about_subtitle') }}</p>
                <div class="item_content">
                    <span class="label">{{ $t('phone') }}：</span>{{ data.phone }}
                </div>
                <div class="item_content">
                    <span class="label">{{ $t('email') }}：</span>{{ data.email }}
                </div>
                <div class="item_content">
                    <span class="label">{{ $t('address') }}：</span>{{ data.address }}
                </div>
            </div>
            <!-- 快捷导航 -->
            <div class="block_content">
                <div class="title_content">{{ $t('quick_navigation') }}</div>
                <div class="item_content1">
                    <div v-for="item in menuList" :key="item.id" class="item_content1_item" @click="jump(1,item.path)">
                        {{ item.name }}
                    </div>
                </div>
            </div>
            <!-- 产品分类 -->
            <div class="block_content">
                <div class="title_content">{{ $t('categories') }}</div>
                <div class="item_content2">
                    <div v-for="item in typeList" :key="item.id" class="item_content2_item" @click="jump(2,item.id)">{{ item.name }}</div>
                </div>
            </div>
            <!-- 微信 -->
            <div class="block_content">
                <div class="title_content">{{ $t('footer_wechat') }}</div>
                <div class="qr-card">
                    <img loading="lazy" src=".././../assets/core/weixin.png" alt="weixin"/>
                </div>
                <div class="qr-tip">{{ $t('footer_follow') }}</div>
            </div>
        </div>
        <div class="footer-bottom">
            <span>© {{ year }} {{ $t('footer_copyright') }}</span>
        </div>
    </div>
</template>
<script>
import {reqListProductsType} from "@/api/core/ProductsType";

export default {
    name: "Bottom",
    async created() {
        await this.loadType();
    },
    methods: {
        jump(type,path) {
            if (type===1){
                this.$router.push({path: path});
                return
            }
            if (type===2){
                this.$router.push({path: '/productsType', query: { typeId: path }})
            }
        },
        async loadType() {
            let {data} = await reqListProductsType({});
            //如果长度大于5，取前5条
            if (data.length > 5) {
                this.typeList = data.slice(0, 5);
            }else{
                this.typeList=data;
            }
        },
    },
    data() {
        return {
            total: 0,
            dataList: [],
            query: {},
            typeList: [],
            year: new Date().getFullYear(),
            data: {
                phone: "+86 186 6961 0526",
                email: "debai@debaiwood.com",
                address: "3309 INTERNATIONAL EXPO CENTER NO.49 SHUANGLING ROAD LANSHAN DIST. LINYI SHANDONG, CHINA",
            },
            menuList: [
                {id: 0, name: this.$t('header_menu.home'), path: "/"},
                {id: 1, name: this.$t('header_menu.about'), path: "/about"},
                {id: 2, name: this.$t('header_menu.product'), path: "/productsType"},
                {id: 3, name: this.$t('header_menu.news'), path: "/news"},
                {id: 4, name: this.$t('header_menu.download'), path: "/download"},
                {id: 5, name: this.$t('header_menu.contact'), path: "/concat"},
            ],
        }
    }
}
</script>
<style scoped lang="scss">
.content {
    background: linear-gradient(135deg, #1b4d33 0%, #246543 100%);
    color: rgba(255, 255, 255, .82);
    position: relative;

    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 4px;
        background: var(--wood);
    }
}

.footer-inner {
    display: flex;
    flex-wrap: wrap;
    max-width: 1200px;
    margin: 0 auto;
    padding: 50px 20px 34px;
}

.block_content {
    width: calc(25% - 20px);
    margin: 0 10px;
    box-sizing: border-box;
}

/* 品牌列 */
.brand-name {
    font-size: 22px;
    font-weight: 800;
    letter-spacing: 1px;
    color: #fff;
    padding-bottom: 14px;
    margin-bottom: 14px;
    border-bottom: 1px solid rgba(255, 255, 255, .15);
}

.brand-desc {
    font-size: 13px;
    line-height: 1.7;
    color: rgba(255, 255, 255, .6);
    margin: 0 0 18px;
}

/* 区块标题 */
.title_content {
    font-size: 15px;
    font-weight: 700;
    color: var(--wood);
    letter-spacing: 1px;
    text-transform: uppercase;
    padding-bottom: 12px;
    margin-bottom: 6px;
    position: relative;

    &::after {
        content: '';
        position: absolute;
        left: 0;
        bottom: 0;
        width: 28px;
        height: 2px;
        background: var(--wood);
    }
}

.item_content {
    padding-top: 12px;
    font-size: 13px;
    line-height: 1.6;
    color: rgba(255, 255, 255, .78);

    .label {
        color: rgba(255, 255, 255, .55);
    }
}

.item_content1 {
    display: flex;
    flex-wrap: wrap;
}

.item_content1_item {
    width: 50%;
    padding-top: 12px;
    cursor: pointer;
    color: rgba(255, 255, 255, .78);
    transition: color .2s, padding-left .2s;

    &:hover {
        color: var(--wood);
        padding-left: 4px;
    }
}

.item_content2_item {
    padding-top: 12px;
    font-size: 13px;
    cursor: pointer;
    color: rgba(255, 255, 255, .78);
    transition: color .2s, padding-left .2s;

    &:hover {
        color: var(--wood);
        padding-left: 4px;
    }
}

/* 微信二维码 */
.qr-card {
    background: #fff;
    padding: 8px;
    border-radius: 8px;
    display: inline-block;

    img {
        width: 130px;
        height: 130px;
        object-fit: contain;
        display: block;
    }
}

.qr-tip {
    margin-top: 10px;
    font-size: 12px;
    color: rgba(255, 255, 255, .6);
}

/* 底部版权条 */
.footer-bottom {
    border-top: 1px solid rgba(255, 255, 255, .12);
    text-align: center;
    padding: 16px 20px;
    font-size: 12px;
    color: rgba(255, 255, 255, .55);
    background: rgba(0, 0, 0, .12);
}

/* PC 窄屏自适应（移动端由 MobileBottom 渲染） */
@media (max-width: 900px) {
    .block_content {
        width: calc(50% - 20px);
        margin-bottom: 24px;
    }
}
</style>
